var render = function render(){var _vm=this,_c=_vm._self._c;return _c('bg-column-list',{attrs:{"label":_vm.label,"sort":_vm.sort,"list":_vm.renderList}})
}
var staticRenderFns = []

export { render, staticRenderFns }